import 'react-app-polyfill/stable';

import { createRoot } from 'react-dom/client';

import App from './App';
import { REACT_ROOT_NODE_ID } from './constants/rootNode';
import reportWebVitals from './reportWebVitals';
import useAnalyticStore from './store/analyticStore/useAnalyticStore';
import useAttributionStore from './store/attributionStore/useAttributionStore';
import useParameterStore from './store/parameterStore/useParameterStore';
import useThemeStore from './store/themeStore/useThemeStore';
import { initialize as initThirdPartyAssets } from './utils/thirdPartyAssets';
import { initializeWorkflowInspect } from './utils/workflow/inspect';

const renderApplication = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  createRoot(document.getElementById(REACT_ROOT_NODE_ID)!).render(<App />);
};

// all dependencies necessary for this application.
const applicationDependencies = [
  initThirdPartyAssets,
  initializeWorkflowInspect,
];

Promise.all(
  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
  applicationDependencies.map((d) => d()),
).then(renderApplication);

const urlSearchParams = new URLSearchParams(window.location.search);

// initialize parameter store states based on URL seach params
useParameterStore.getState().setFromURLSearchParams(urlSearchParams);

// initialize attribution store based on URL and search params
useAttributionStore.getState().setFromURLSearchParams(urlSearchParams);
useAttributionStore.getState().setInitialURL(new URL(window.location.href));

// initialize analytic elements tracking
useAnalyticStore.getState().bindElementAnalyticsListeners();

// initialize theme store layout height measurement
useThemeStore.getState().initializePageHeightMeasurement();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
